









helpers = require('../../../../helpers.coffee')

view_model = {
  props: ['notification', 'table']

  data: ->
    current_user: Session.current_user
    go_to: '/tarefas'


  computed:
    pre_text: ->
      if @notification.count > 1
        "Foram criadas "
      else
        "Foi criada "

    name: ->
      if @manager_and_not_owner
        @notification.user?.name
      else
        'Você'

    text: ->
      if @notification.count > 1
        @notification.count + ' Ozzy Tasks'
      else
        ' 1 Ozzy Task'
}

exports.default = helpers.vue_include(view_model, helpers.notifications.kind_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/kind/ozzy_task.vue